export const API_KEY = 'AIzaSyDmVXeGg1VJAc_rFX8dX2GZcKOPow_lIOI';

export default API_KEY